import ProgressBarItem from './components/ProgressBarItem';
import { useProgressBarContext } from './context';

const ProgresBarContent: React.FunctionComponent = function () {
  const { modifiedItems } = useProgressBarContext();
  return (
    <div className="flex flex-col">
      {modifiedItems.map(({ key, ...rest }) => (
        <ProgressBarItem key={key} {...rest} />
      ))}
    </div>
  );
};

export default ProgresBarContent;
